import { memo, useRef } from 'react';
import { getMallList } from '@/apis';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import RowItem from '../components/RowItem';
import { languageMap } from '@/locale';
import ProductItem from '@/components/ProductItem';
import { ProductKindItem, OrderingEnum } from '@/stores';
import { Spin, Empty } from 'antd';
import styles from './index.module.scss';
import { useNavigate } from 'react-router-dom';

interface Props {
  info: ProductKindItem;
}

const NewProduct: React.FC<Props> = ({ info }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const total = useRef(0);
  const { data: newList, isFetching } = useQuery(
    [getMallList.name, info.id],
    async () => {
      const res = await getMallList({
        class_id: info.id,
        page: 1,
        page_size: 8,
        ordering: OrderingEnum.id,
      });
      total.current = res.data?.total ?? 0;
      return (
        res.data?.list?.map((item) => ({
          ...item,
          classid: info.id,
          class_type: 1,
        })) ?? []
      );
    },
    {
      enabled: !!info.id,
    },
  );
  // const sItem = newList?.[0];
  // const restList = newList?.slice(1);
  const linkToAll = () => {
    const ename = (info.ename || '').replace(/\s*/g, '');
    navigate(`/mall/${ename}`);
  };
  return (
    <div className={styles.container}>
      <Spin className="center-loading" delay={300} spinning={isFetching} />
      <span className={styles.view} onClick={linkToAll}>
        View All
      </span>
      <RowItem title={info[languageMap[i18n.language]]}>
        <div className={styles.wrap}>
          {/* {sItem && (
            <div className={styles.sItem}>
              <ProductItem descClassName={styles.sItemDesc} info={sItem} />
            </div>
          )} */}
          {newList && newList.length > 0 && (
            <div className={styles.rest}>
              {newList.map((item) => (
                <div className={styles.item} key={item.id}>
                  <ProductItem info={item} />
                </div>
              ))}
            </div>
          )}
        </div>
        {newList && newList.length === 0 && <Empty />}
      </RowItem>
    </div>
  );
};

export default memo(NewProduct);
